import { Chip } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

/**
 * Small status badge shown next to a vendor/dealer whose contract relationship
 * has been unlinked (set inactive). Muted red tint, bold, uppercase.
 */
const UnlinkedChip = ({ label, size = 'small', sx, ...props }) => {
  const { t } = useTranslation('global');

  return (
    <Chip
      label={label || t('unlinked')}
      size={size}
      sx={theme => ({
        fontWeight: 700,
        textTransform: 'uppercase',
        color: theme.palette.error.dark,
        bgcolor: alpha(theme.palette.error.main, 0.12),
        ...sx,
      })}
      {...props}
    />
  );
};

export default UnlinkedChip;
